(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["get-a-quote"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-sc-quote-dialog]');
    if (!dialog || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    const form = dialog.querySelector('#SCGetAQuoteForm');
    const category = dialog.querySelector('[data-sc-quote-category]');
    const flavor = dialog.querySelector('#SCQuoteFlavor');
    const source = form?.elements['contact[Form source]'];
    const defaultSource = source?.value || 'Floating Get a Quote button';
    const firstField = category || dialog.querySelector('input, select, textarea');
    const errors = dialog.querySelector('[data-sc-quote-errors]');
    const fields = dialog.querySelector('[data-sc-quote-fields]');
    const success = dialog.querySelector('[data-sc-quote-success]');
    const submitButton = dialog.querySelector('[data-sc-quote-submit]');

    const setBusy = (busy) => {
      if (!submitButton) return;
      submitButton.disabled = busy;
      submitButton.setAttribute('aria-busy', String(busy));
    };

    const openDialog = (requestedCategory, requestedSource, requestedFlavor) => {
      if (requestedCategory && category) {
        const matchingOption = Array.from(category.options).find((option) => option.value === requestedCategory);
        if (matchingOption) category.value = matchingOption.value;
      }
      if (requestedFlavor && flavor) flavor.value = requestedFlavor;
      if (source) source.value = requestedSource || defaultSource;
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('sc-quote-open');
      window.requestAnimationFrame(() => firstField?.focus());
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
      document.body.classList.remove('sc-quote-open');
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-sc-quote-open]');
      if (opener) {
        event.preventDefault();
        openDialog(opener.dataset.category || '', opener.dataset.formSource || '', opener.dataset.flavor || '');
        return;
      }
      if (event.target.closest('[data-sc-quote-close]')) closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove('sc-quote-open');
      setBusy(false);
    });

    form?.addEventListener('submit', (event) => {
      if (!form.checkValidity()) return;
      // Native Shopify contact-form submission (delivers to the store contact
      // email). Do not intercept with fetch: Shopify may redirect or challenge
      // AJAX posts, which previously surfaced as a generic send failure.
      try {
        sessionStorage.setItem('scQuoteSubmitted', '1');
      } catch (error) {}
      setBusy(true);
    });

    if ((success && !success.hidden) || (errors && !errors.hidden)) openDialog();
  })();

  (() => {
    const WORKER_URL = 'https://scream-sample-checkout.adfun9.workers.dev/create-checkout-session';
    const flavorData = document.querySelector('#SCFlavorOptions');
    const FLAVORS = flavorData ? JSON.parse(flavorData.textContent) : [];
    const EU_GB = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];
    const SAMPLE_PRICE = 10, INCLUDED = 4, EXTRA = 3.5;

    const trigger = document.querySelector('[data-sc-choice-open]');
    const menu = document.querySelector('[data-sc-choice-menu]');
    const sampleDialog = document.querySelector('[data-sc-sample-dialog]');
    if (!trigger || !menu || !sampleDialog || sampleDialog.dataset.initialized === 'true') return;
    sampleDialog.dataset.initialized = 'true';

    const closeMenu = () => { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
    const toggleMenu = () => {
      const willOpen = menu.hidden;
      menu.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', String(willOpen));
    };
    trigger.addEventListener('click', (event) => { event.stopPropagation(); toggleMenu(); });
    document.addEventListener('click', (event) => {
      if (!menu.hidden && !menu.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
    menu.addEventListener('click', () => closeMenu());

    const form = sampleDialog.querySelector('#SCSampleForm');
    const rowsWrap = sampleDialog.querySelector('[data-sc-sample-rows]');
    const chipsWrap = sampleDialog.querySelector('[data-sc-sample-chips]');
    const datalist = sampleDialog.querySelector('#SCFlavorList');
    const errorBox = sampleDialog.querySelector('[data-sc-sample-error]');
    const submitBtn = sampleDialog.querySelector('[data-sc-sample-submit]');
    const countrySel = sampleDialog.querySelector('#SCSampleCountry');

    FLAVORS.forEach((f) => {
      const opt = document.createElement('option');
      opt.value = f;
      datalist.appendChild(opt);
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'sc-sample-chip';
      chip.textContent = f;
      chip.addEventListener('click', () => {
        const emptyRow = Array.from(rowsWrap.querySelectorAll('.sc-sample-row')).find((r) => !r.querySelector('[data-f]').value.trim());
        if (emptyRow) { emptyRow.querySelector('[data-f]').value = f; updateSummary(); }
        else addRow(f);
      });
      chipsWrap.appendChild(chip);
    });

    const money = (n) => 'USD ' + n.toFixed(2);
    const baseShipping = () => {
      const c = countrySel.value;
      if (!c) return null;
      if (c === 'AU') return 54;
      return 47; // US and EU + GB
    };
    const collect = () => Array.from(rowsWrap.querySelectorAll('.sc-sample-row')).map((row) => ({
      flavor: row.querySelector('[data-f]').value.trim(),
      strength: Number(row.querySelector('[data-s]').value),
      qty: Math.max(1, Math.min(20, Number(row.querySelector('[data-q]').value) || 1)),
    }));
    const updateSummary = () => {
      const items = collect();
      const boxes = items.reduce((a, i) => a + i.qty, 0);
      const subtotal = boxes * SAMPLE_PRICE;
      const base = baseShipping();
      const extraBoxes = Math.max(0, boxes - INCLUDED);
      const extra = base === null ? 0 : extraBoxes * EXTRA;
      sampleDialog.querySelector('[data-sc-sum-samples]').textContent = money(subtotal);
      sampleDialog.querySelector('[data-sc-sum-shipping]').textContent = base === null ? 'Select country' : money(base);
      const extraRow = sampleDialog.querySelector('[data-sc-sum-extra-row]');
      extraRow.hidden = !(base !== null && extra > 0);
      sampleDialog.querySelector('[data-sc-sum-extra]').textContent = money(extra);
      sampleDialog.querySelector('[data-sc-sum-total]').textContent = base === null ? money(subtotal) : money(subtotal + base + extra);
      rowsWrap.querySelectorAll('.sc-sample-row__remove').forEach((b) => { b.disabled = rowsWrap.children.length <= 1; });
    };
    const addRow = (flavor = '') => {
      if (rowsWrap.children.length >= 20) return;
      const row = document.createElement('div');
      row.className = 'sc-sample-row';
      row.innerHTML =
        '<div class="sc-quote-field"><label>Flavor</label><input data-f list="SCFlavorList" placeholder="Pick or type a flavor" value="' + flavor.replace(/"/g, '&quot;') + '"></div>' +
        '<div class="sc-quote-field"><label>Caffeine</label><select data-s><option value="50">50mg</option><option value="100">100mg</option></select></div>' +
        '<div class="sc-quote-field"><label>Boxes</label><input data-q type="number" min="1" max="20" value="1"></div>' +
        '<button type="button" class="sc-sample-row__remove" aria-label="Remove sample">&times;</button>';
      row.querySelector('.sc-sample-row__remove').addEventListener('click', () => { row.remove(); updateSummary(); });
      row.addEventListener('input', updateSummary);
      row.addEventListener('change', updateSummary);
      rowsWrap.appendChild(row);
      updateSummary();
    };
    addRow('');
    sampleDialog.querySelector('[data-sc-sample-add]').addEventListener('click', () => addRow(''));
    countrySel.addEventListener('change', updateSummary);

    const openSample = () => {
      if (!sampleDialog.open) sampleDialog.showModal();
      document.body.classList.add('sc-quote-open');
    };
    const closeSample = () => {
      if (sampleDialog.open) sampleDialog.close();
      document.body.classList.remove('sc-quote-open');
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-sc-sample-open]')) { event.preventDefault(); openSample(); }
      if (event.target.closest('[data-sc-sample-close]')) closeSample();
    });
    sampleDialog.addEventListener('click', (event) => { if (event.target === sampleDialog) closeSample(); });
    sampleDialog.addEventListener('close', () => document.body.classList.remove('sc-quote-open'));

    const showError = (msg) => {
      errorBox.textContent = msg;
      errorBox.hidden = !msg;
      if (msg) errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      showError('');
      const name = sampleDialog.querySelector('#SCSampleName').value.trim();
      const email = sampleDialog.querySelector('#SCSampleEmail').value.trim();
      const phone = sampleDialog.querySelector('#SCSamplePhone').value.trim();
      const items = collect();
      if (name.length < 2) return showError('Please enter your full name.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError('Please enter a valid email address.');
      if (phone.length < 6) return showError('Please enter your phone number — the courier needs it for delivery.');
      if (!countrySel.value) return showError('Please select your shipping country.');
      if (items.some((i) => !i.flavor)) return showError('Please pick or type a flavor for every sample row.');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Redirecting to secure checkout...';
      try {
        const res = await fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name, email, phone,
            country: countrySel.value,
            note: sampleDialog.querySelector('#SCSampleNote').value.trim(),
            items,
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.url) throw new Error(data.error || 'Something went wrong. Please try again.');
        window.location.href = data.url;
      } catch (err) {
        showError(err.message || 'Something went wrong. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Pay securely with Stripe';
      }
    });
    updateSummary();
  })();

  (() => {
    // GA4 click tracking for the Quote / Sample entry points (country comes from GA4 geo by IP).
    document.addEventListener('click', (event) => {
      if (typeof gtag !== 'function') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      let name = null;
      if (target.closest('[data-sc-sample-open]')) name = 'sc_sample_open';
      else if (target.closest('[data-sc-quote-open]')) name = 'sc_quote_open';
      else if (target.closest('[data-sc-choice-open]')) name = 'sc_entry_click';
      if (name) {
        try { gtag('event', name, { page_path: window.location.pathname }); } catch (error) {}
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
